<template>
  <biz-project-form v-if="formConfig.formKey" ref="bizProjectForm" :form-config="formConfig" />
</template>

<script>
import BizProjectForm from '@/components/FormGen/BizProjectForm/index'
// import 'tduck-form-generator/dist/TduckForm.css'
import mixin from '../TduckFormMixin'

export default {
  components: {
    BizProjectForm
  },
  mixins: [mixin],
  data() {
    return {
      formConfig: {
        formKey: '',
        preview: true,
        showBtns: true,
        showItem: 'start',
        isPcOrMobile: 'Mobile'
      }
    }
  },
  provide() {
    return {
      formWriteSubmit: () => {},
      formConfig: this.formConfig
    }
  },
  created() {
    this.formConfig.formKey = this.$route.query.key
  },
  methods: {
    // submitForm() {
    //   if(this.$refs.bizProjectForm){
    //     this.$refs.bizProjectForm.getShowModule()
    //   }
    // }
  }
}
</script>
<style scoped lang="scss">
::v-deep .project-form {
  overflow-x: hidden !important;
  // padding: 5px !important;
}
::v-deep .project-form {
  padding: 20px;
}
</style>
